import { render, staticRenderFns } from "./ipasasFaPermissions.vue?vue&type=template&id=7e475656&scoped=true&"
import script from "./ipasasFaPermissions.vue?vue&type=script&lang=js&"
export * from "./ipasasFaPermissions.vue?vue&type=script&lang=js&"
import style0 from "./ipasasFaPermissions.vue?vue&type=style&index=0&id=7e475656&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e475656",
  null
  
)

export default component.exports